import { OutvioStatusCodes } from '../Interfaces';

const INCIDENT_STATUS_TEXT_KEYS: { [key in OutvioStatusCodes]?: string } = {
  [OutvioStatusCodes.BAD_ADDRESS]: 'general.status.BAD_ADDRESS',
  [OutvioStatusCodes.CANCELLED]: 'general.status.CANCELLED',
  [OutvioStatusCodes.DAMAGED]: 'general.status.DAMAGED',
  [OutvioStatusCodes.DELAYED]: 'general.status.DELAYED',
  [OutvioStatusCodes.DESTROYED]: 'general.status.DESTROYED',
  [OutvioStatusCodes.IMPORTANT_INCIDENTS]: 'general.status.IMPORTANT_INCIDENTS',
  [OutvioStatusCodes.LOST]: 'general.status.LOST',
  [OutvioStatusCodes.MISSING_DOCUMENTATION]: 'general.status.MISSING_DOCUMENTATION',
  [OutvioStatusCodes.NOT_AT_HOME]: 'general.status.NOT_AT_HOME',
  [OutvioStatusCodes.OTHER_INCIDENTS]: 'general.status.OTHER_INCIDENTS',
  [OutvioStatusCodes.PARTIALLY_DELIVERED]: 'general.status.PARTIALLY_DELIVERED',
  [OutvioStatusCodes.REFUSED]: 'general.status.REFUSED',
  [OutvioStatusCodes.RETURN_TO_ORIGIN]: 'general.status.RETURNED_TO_ORIGIN',
  [OutvioStatusCodes.STOLEN]: 'general.status.STOLEN',
};

export const getIncidentStatusTextKey = (code: OutvioStatusCodes): string | undefined =>
  INCIDENT_STATUS_TEXT_KEYS[code];

export const toStepCase = (text: string): string => {
  const trimmed = text.trim();
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
};
